(() => {
  'use strict';
  function init(root) {
    if (root.dataset.studyReady) return;
    root.dataset.studyReady = 'true';
    const data = JSON.parse(root.querySelector('[data-study-data]').textContent);
    const buttons = Array.from(root.querySelectorAll('[data-study-card]'));
    const selector = document.getElementById('cpm-vsel');
    const status = root.querySelector('[role="status"]');
    const cards = Array.from(root.querySelectorAll('.cstudy__card'));
    const svgNS = 'http://www.w3.org/2000/svg';
    function positionAnnotations(card, drawing, img, annotations) {
      drawing.classList.add('cstudy__drawing--annotated');
      card.classList.add('cstudy__card--annotated');
      let overlay = drawing.querySelector('.cstudy__annotations');
      if (!overlay) {
        overlay = document.createElement('span');
        overlay.className = 'cstudy__annotations';
        drawing.appendChild(overlay);
      }
      overlay.replaceChildren();
      let summary = card.querySelector('.cstudy__measure-summary');
      if (!summary) {
        summary = document.createElement('span');
        summary.className = 'cstudy__measure-summary';
        drawing.insertAdjacentElement('afterend', summary);
      }
      summary.replaceChildren();
      annotations.forEach(a => {
        if (!a.summary_label || !a.summary_value) return;
        const row = document.createElement('span');
        row.className = 'cstudy__secondary';
        const name = document.createElement('span'); name.textContent = a.summary_label;
        const value = document.createElement('strong'); value.textContent = a.summary_value;
        row.append(name, value); summary.appendChild(row);
      });
      const rect = img.getBoundingClientRect();
      const stage = drawing.getBoundingClientRect();
      const scale = Math.min(rect.width / img.naturalWidth, rect.height / img.naturalHeight);
      const w = img.naturalWidth * scale, h = img.naturalHeight * scale;
      const left = rect.left - stage.left + (rect.width - w) / 2;
      const top = rect.top - stage.top + (rect.height - h) / 2;
      const svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('width', '100%'); svg.setAttribute('height', '100%');
      svg.setAttribute('aria-hidden', 'true'); overlay.appendChild(svg);
      function line(x1, y1, x2, y2, extension) {
        const el = document.createElementNS(svgNS, 'line');
        Object.entries({x1,y1,x2,y2}).forEach(([key,value]) => el.setAttribute(key, value));
        if (extension) el.setAttribute('class', 'cstudy__extension');
        svg.appendChild(el);
      }
      annotations.forEach(a => {
        const x1 = left + a.x1*w, x2 = left + a.x2*w;
        const y1 = top + a.y1*h, y2 = top + a.y2*h;
        line(x1,y1,x2,y2);
        if (a.axis === 'h') { line(x1,y1-4,x1,y1+4); line(x2,y2-4,x2,y2+4); }
        else if (a.axis === 'leader') {
          const point = document.createElementNS(svgNS, 'circle');
          point.setAttribute('cx', x1); point.setAttribute('cy', y1);
          point.setAttribute('r', '2'); point.setAttribute('fill', 'currentColor');
          svg.appendChild(point);
        }
        else if (a.axis === 'd') {
          const length = Math.hypot(x2-x1, y2-y1) || 1;
          const dx = -(y2-y1) / length * 4, dy = (x2-x1) / length * 4;
          line(x1-dx,y1-dy,x1+dx,y1+dy); line(x2-dx,y2-dy,x2+dx,y2+dy);
        }
        else { line(x1-4,y1,x1+4,y1); line(x2-4,y2,x2+4,y2); }
        const label = document.createElement('span');
        label.className = 'cstudy__annotation-label';
        label.textContent = a.label;
        label.style.top = (a.label_side === 'above' ? y1-26 : top+a.label_y*h)+'px';
        overlay.appendChild(label);
        const labelInset = label.getBoundingClientRect().width / 2 + 3;
        label.style.left = Math.max(labelInset, Math.min(stage.width-labelInset, left+a.label_x*w))+'px';
      });
    }
    function positionMeasures() {
      cards.forEach((card, index) => {
        const drawing = card.querySelector('.cstudy__drawing');
        const img = card.querySelector('img');
        const measure = data.cards[index].bounds;
        if (!img.naturalWidth) return;
        if (data.cards[index].annotations && data.cards[index].annotations.length) {
          positionAnnotations(card, drawing, img, data.cards[index].annotations);
          return;
        }
        let summary = card.querySelector('.cstudy__measure-summary');
        if (!summary) {
          summary = document.createElement('span');
          summary.className = 'cstudy__measure-summary';
          (card.querySelector('.cstudy__width') || drawing).insertAdjacentElement('afterend', summary);
          const source = data.cards[index];
          const rows = [];
          if (source.height_label) rows.push({label:'Hauteur',value:source.height_label});
          if (source.width_label) rows.push({label:source.width_label.trim().startsWith('Ø') ? 'Diamètre' : 'Largeur',value:source.width_label});
          rows.push(...(source.details || []));
          rows.forEach(item => {
            const row = document.createElement('span'); row.className = 'cstudy__secondary';
            const label = document.createElement('span'); label.textContent = item.label;
            const value = document.createElement('strong'); value.textContent = item.value;
            row.append(label,value); summary.appendChild(row);
          });
        }
        if (!measure) return;
        const rect = img.getBoundingClientRect();
        const stage = drawing.getBoundingClientRect();
        const scale = Math.min(rect.width / img.naturalWidth, rect.height / img.naturalHeight);
        const h = img.naturalHeight * scale;
        const w = img.naturalWidth * scale;
        const top = rect.top - stage.top + (rect.height-h)/2;
        const line = card.querySelector('.cstudy__height');
        if (line) {
          line.style.position = 'absolute';
          line.style.right = '0';
          line.style.top = (top+h*measure.top)+'px';
          line.style.height = (h*(measure.bottom-measure.top))+'px';
          line.style.width = getComputedStyle(drawing).gridTemplateColumns.split(' ').pop();
        }
        const width = card.querySelector('.cstudy__width');
        if (width && Number.isFinite(measure.left) && Number.isFinite(measure.right)) {
          const offset = w * ((measure.left + measure.right) / 2 - .5);
          width.querySelector('.cstudy__width-line').style.width = (w * (measure.right - measure.left)) + 'px';
          Array.from(width.children).forEach(el => el.style.transform = 'translateX(' + offset + 'px)');
        }
      });
    }
    cards.forEach(card => {
      const img = card.querySelector('img');
      const originalSrc = img.src;
      let retries = 0;
      function retryImage() {
        if (retries >= 2) return;
        retries += 1;
        window.setTimeout(() => {
          const retryUrl = new URL(originalSrc, window.location.href);
          retryUrl.searchParams.set('cstudy_retry', String(retries));
          img.src = retryUrl.href;
        }, retries * 800);
      }
      img.addEventListener('load', positionMeasures);
      img.addEventListener('error', retryImage);
      if (img.complete && !img.naturalWidth) retryImage();
    });
    new ResizeObserver(positionMeasures).observe(root);
    positionMeasures();
    if (!selector || !buttons.length) return;
    const ids = card => new Set(card.variant_ids.map(String));
    function sync() {
      buttons.forEach(button => {
        const members = ids(data.cards[Number(button.dataset.studyCard)]);
        button.setAttribute('aria-pressed', String(members.has(String(selector.value))));
        const available = data.variants.some(v => members.has(String(v.id)) && v.available);
        button.setAttribute('aria-disabled', String(!available));
      });
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      const card = data.cards[Number(button.dataset.studyCard)];
      const members = ids(card);
      const current = data.variants.find(v => String(v.id) === String(selector.value));
      const candidates = data.variants.filter(v => members.has(String(v.id)) && v.available);
      if (!candidates.length) { status.textContent = 'Cette configuration est actuellement épuisée.'; return; }
      // Keep current finish/light choices whenever a matching size combination exists.
      const score = v => [1,2,3].reduce((n,k) => n + (current && v['option'+k] === current['option'+k] ? 1 : 0), 0);
      candidates.sort((a,b) => score(b)-score(a));
      const target = candidates[0];
      const scrollPosition = { top: window.scrollY, left: window.scrollX, behavior: 'instant' };
      for (let position = 1; position <= 3; position++) {
        const value = target['option'+position];
        if (!value) continue;
        const group = document.querySelector('.cpm-opts-group[data-option-position="'+position+'"]');
        const pill = group && Array.from(group.querySelectorAll('.cpm-pill')).find(p => p.dataset.value === value);
        if (pill && !pill.classList.contains('is-active')) pill.click();
      }
      // Native gallery thumbnails may scroll the page; keep the chosen study in view.
      window.scrollTo(scrollPosition);
      sync();
      requestAnimationFrame(positionMeasures);
      status.textContent = String(selector.value) === String(target.id) ? '' : 'Sélectionnez cette configuration dans les options du produit.';
    }));
    selector.addEventListener('change', () => { sync(); requestAnimationFrame(positionMeasures); });
    root.addEventListener('focusin', sync);
    window.addEventListener('pageshow', sync);
    sync();
  }
  document.querySelectorAll('[data-candela-study]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-candela-study]').forEach(init));
})();
